import { getOrganizationIcon } from '@shared/constants/organization/OrganizationValues';
import OrganizationMemberDetailsModel from '@shared/models/organizations/OrganizationMemberDetailsModel';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import ActionRow from '../core/row/ActionRow';

export interface IOrgActionRowProps {
    membership: OrganizationMemberDetailsModel;
}

export default function OrgActionRow({ membership }: IOrgActionRowProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate(`../org/${membership.organizationId}`);
    };

    if (!membership || !membership.organization || !membership.organizationId) return null;
    return (
        <ActionRow
            iconSize={24}
            startIcon={getOrganizationIcon(membership.organization)}
            title={membership.organization.name}
            description={membership.organization.description}
            onClick={handleNavigate}></ActionRow>
    );
}
